// extracted by mini-css-extract-plugin
module.exports = {"events__empty-state":"EmptyState_events__empty-state__NDmR6"};